/* eslint-disable arrow-body-style */
import { useEffect, useState } from 'react';
import { useShallow } from 'zustand/shallow';
import Text from '../../assets/styles/Text';
import { useStore } from '../../stores/index';
import * as styles from './styles';

export default function PriceRangeFilter() {
  const { priceRange, setPriceMin, setPriceMax, clearPriceRange } = useStore(
    useShallow((state) => ({
      priceRange: state.priceRange,
      setPriceMin: state.setPriceMin,
      setPriceMax: state.setPriceMax,
      clearPriceRange: state.clearPriceRange,
    }))
  );

  const [localMin, setLocalMin] = useState(priceRange.min);
  const [localMax, setLocalMax] = useState(priceRange.max);
  const [error, setError] = useState('');

  // Sync prince
  useEffect(() => {
    setLocalMin(priceRange.min);
    setLocalMax(priceRange.max);
  }, [priceRange.min, priceRange.max]);

  // Format BRL R$
  function formatCurrency(value) {
    if (!value) return '';
    const numValue = value.replace(/\D/g, '');
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(numValue / 100);
  }

  // Remove format return number
  function unformatCurrency(value) {
    return value.replace(/\D/g, '');
  }

  function handleMinChange(e) {
    const rawValue = unformatCurrency(e.target.value);
    setLocalMin(rawValue);
    setError('');
  }

  function handleMaxChange(e) {
    const rawValue = unformatCurrency(e.target.value);
    setLocalMax(rawValue);
    setError('');
  }

  function handleBlur() {
    const minValue = parseFloat(localMin) || 0;
    const maxValue = parseFloat(localMax) || 0;

    // Validation
    if (localMax && minValue > maxValue) {
      setError('Valor mínimo não pode ser maior que o máximo');
      return;
    }

    // Update store onBlur
    setPriceMin(localMin);
    setPriceMax(localMax);
  }

  function handleClear() {
    setLocalMin('');
    setLocalMax('');
    setError('');
    clearPriceRange();
  }

  const hasValue = localMin || localMax;

  return (
    <styles.Container>
      <Text.P>Valor</Text.P>

      <styles.InputGroup>
        <styles.InputWrapper>
          <label htmlFor="price-min">
            <Text.Span>De:</Text.Span>
          </label>
          <styles.Input
            id="price-min"
            type="text"
            placeholder="Mínimo"
            value={localMin ? formatCurrency(localMin) : ''}
            onChange={handleMinChange}
            onBlur={handleBlur}
          />
        </styles.InputWrapper>

        <styles.InputWrapper>
          <label htmlFor="price-max">
            <Text.Span>Até:</Text.Span>
          </label>
          <styles.Input
            id="price-max"
            type="text"
            placeholder="Máximo"
            value={localMax ? formatCurrency(localMax) : ''}
            onChange={handleMaxChange}
            onBlur={handleBlur}
          />
        </styles.InputWrapper>

        {hasValue && (
          <styles.ClearButton onClick={handleClear} type="button">
            <Text.Span>Limpar</Text.Span>
          </styles.ClearButton>
        )}
      </styles.InputGroup>

      {error && (
        <styles.ErrorMessage>
          <Text.Span>{error}</Text.Span>
        </styles.ErrorMessage>
      )}
    </styles.Container>
  );
}
